import { appstr } from "./appstr";
import { enumDocLoadType, enumKeyboardTargetEnterAction, enumUIModes } from "../constants";
import { QAlert } from "../CoreApp/QAlert";
import { QXDoc } from "../CoreApp/QXDoc";
import { QXDocMgr } from "../CoreApp/QXDocMgr";
import { Globals } from "../CoreApp/Globals";

export function finishstddownload() {
  var w = Globals._wsRefFinishDownload;
  Globals._wsRefFinishDownload = null;
  var docMgr;
  var loadType = w["loadtype"];
  var standardLoad = loadType === enumDocLoadType.standard;
  if (standardLoad) docMgr = w.GetDocMgr();
  else {
    docMgr = new QXDocMgr();
    docMgr.InitDocMgr(w);
  }

  var theData = w["downloaddata"];
  var fileName = w["downloadfile"];
  var directory = w["downloaddir"];
  var isLocked = w["downloadlocked"];
  var topboxID = w["downloadtopbox"];
  var startDiv = w["downloaddiv"];
  [
    "loadtype",
    "downloaddata",
    "downloadfile",
    "downloaddir",
    "downloadlocked",
    "downloadtopbox",
    "downloaddiv"
  ].forEach(prop => {
    w[prop] = null;
    delete w[prop];
  });
  w.fBackgroundMgr.ResetCurrentBackground();
  docMgr.SetFileName(fileName);
  docMgr.SetFileDirectory(directory, isLocked);
  docMgr.LoadDocumentData(theData);
  var loadDocument = docMgr.GetFirstDocument(startDiv);
  var accessPass = true;
  var amEnabled = docMgr.AccessMgrEnabled();
  if (loadDocument == null) accessPass = false;
  else {
    if (amEnabled) {
      var am = docMgr.GetAccessMgr();
      accessPass = am.CanAccessCurrentDoc();
    }
  }

  if (accessPass) {
    if (amEnabled) docMgr.SetFileDirectory(directory, amEnabled);
    if (standardLoad) {
      var loadSettings = Globals._accountInfo.GetLaunchSettings();
      Globals._accountInfo.ClearLaunchSettings();
      loadSettings.topboxID = topboxID;
      w.PrepDocumentLoad(loadDocument);
      docMgr.HandleDocumentLoad(loadDocument, loadSettings);
      w.SignalDocumentLoadComplete();
    } else {
      w.DoCompareDoc(docMgr);
    }

    w.EndProgress();
    w.SetKeyboardTarget(null, w.GetCurrentPanel(), enumKeyboardTargetEnterAction.none);
  } else {
    w.EndProgress();
    w.CloseDocument(false);
    var alertP = new QAlert();
    alertP.InitAlert(appstr("Alert"), appstr("accesserr1"), null, w);
  }

  if (Globals._uiConfig.GetUIMode() === enumUIModes.edit) setTimeout(w.DoPrompt.bind(w), 1500);

  w.PrepRenderWS();
  w.RenderWS();
}
